// extracted by mini-css-extract-plugin
export default {"container":"container-bTJuAneH","heading":"heading-NkVL3aRt","volumeContainer":"volumeContainer-JkCimI8c","volumeText":"volumeText-uyI3YuBU","volumeSlider":"volumeSlider-n8lhXEOm"};